import { HowToDeposit } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('How to Deposit');
      },
    },
  },
};

export default HowToDeposit;
